<app-hero></app-hero>
<app-about-us></app-about-us>
<app-video-showcase-section></app-video-showcase-section>
<app-smart-features></app-smart-features>
<app-pricing-section></app-pricing-section>
<app-management-services></app-management-services>
<app-solutions-section></app-solutions-section>
<app-feature-walkthrough></app-feature-walkthrough>
<app-why-choose-us></app-why-choose-us>
<app-logo-slider></app-logo-slider>
<app-money-back-slider></app-money-back-slider>